import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=8f31436c&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=ts"
export * from "./_slug.vue?vue&type=script&lang=ts"
import style0 from "./_slug.vue?vue&type=style&index=0&id=8f31436c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f31436c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticlesSlider: require('/usr/src/app/components/Articles/ArticlesSlider.vue').default,InfoBlock: require('/usr/src/app/components/InfoBlocks/InfoBlock.vue').default})
